import React from 'react';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AppNavButton from './Components/AppNavButton';

const UploadNav = () => {
	return (
		<AppNavButton text="Upload Files" showGroupingMenu={true} path="/uploadfiles" icon={<CloudUploadIcon />} />
	);
};

export default UploadNav;
